var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "341 -113.1 45 32",
    enableBackground: "new 341 -113.1 45 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -371.8,
    y: -345,
    width: 969.8,
    height: 713.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 511.5,
    y: 370.4,
    width: 75.1,
    height: 29.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -3.051758e-05)",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 1710,
    height: 1276,
    xlinkHref: "Screen Shot 2014-08-07 at 1.16.05 PM.png",
    transform: "matrix(0.6175 0 0 0.6175 -345.4637 -358.1656)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M371.5-93.7c-0.3,0-0.6-0.2-0.8-0.4l-5.5-9.1c-0.3-0.4-0.1-1,0.3-1.2c0.4-0.3,1-0.1,1.2,0.3l5.5,9.1 c0.3,0.4,0.1,1-0.3,1.2C371.8-93.7,371.7-93.7,371.5-93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M374.6-82.5c-3.7,0-6.7-2.9-6.9-6.6c-0.2-3.8,2.8-7,6.6-7.2c3.9-0.2,7,2.8,7.2,6.6c0.1,1.8-0.5,3.6-1.8,5 s-2.9,2.2-4.8,2.2C374.8-82.6,374.7-82.5,374.6-82.5z M374.6-94.6c-0.1,0-0.2,0-0.2,0c-2.8,0.1-5,2.5-4.9,5.4 c0.1,2.8,2.5,5,5.4,4.9c1.4-0.1,2.6-0.7,3.5-1.7c0.9-1,1.4-2.3,1.3-3.7C379.6-92.4,377.4-94.6,374.6-94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M352.4-82.5c-0.5,0-1-0.1-1.5-0.2c-1.8-0.4-3.3-1.4-4.3-3c-1-1.5-1.3-3.4-1-5.2c0.7-3.2,3.5-5.4,6.7-5.4 c0.5,0,1,0.1,1.5,0.2c3.7,0.8,6.1,4.5,5.3,8.2C358.4-84.8,355.6-82.5,352.4-82.5z M352.4-94.6c-2.4,0-4.5,1.7-5,4 c-0.3,1.3,0,2.7,0.7,3.9c0.7,1.1,1.9,1.9,3.2,2.2c0.4,0.1,0.7,0.1,1.1,0.1c2.4,0,4.5-1.7,5-4c0.6-2.8-1.2-5.5-3.9-6.1 C353.1-94.5,352.7-94.6,352.4-94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M373-102.3h-4.9c0,0-2.5-4-3-4.5c-0.9-0.8-2.2-0.7-3,0.2l-5.7,6.6c-0.8,0.9-0.7,2.2,0.2,3 c0.4,0.3,6.8,3,6.8,3l-1.2,5.1c-0.2,0.9,0.3,1.7,1.2,1.9c0.1,0,0.3,0,0.4,0c0.7,0,1.4-0.5,1.6-1.2l1.5-6.3c0.2-0.7-0.2-1.5-0.8-1.8 l-5-2.6l3.8-4.4l1.9,2.5c0.2,0.3,0.5,0.4,0.8,0.4h5.4c0.6,0,1.1-0.5,1.1-1.1S373.6-102.3,373-102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M361.4-109.3c0.8,0.7,0.7,2-0.2,3l-4.2,4.6c-0.9,0.9-2.2,1.1-3,0.4l0,0c-0.8-0.7-0.7-2,0.2-3l4.2-4.6 C359.3-109.8,360.6-110,361.4-109.3L361.4-109.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3C3C3B",
    cx: 368.7,
    cy: -108.7,
    r: 2.9
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.dc2c1833997ce9954fae718486788471.svg";
export { ForwardRef as ReactComponent };